import React from 'react';

import { DocumentationLink } from 'components/support';
import DocsHelper from 'util/DocsHelper';
import useSearchVersionCheck from 'hooks/useSearchVersionCheck';
import { ExternalLink } from 'components/common';

const WarmTierSnapshotsText = () => {
  const { data, isLoading } = useSearchVersionCheck('datanode');

  const showDataNodeText = !isLoading && data?.satisfied;

  return (
    <p>
      {showDataNodeText ? 'Data Node ' : 'At least one node in the cluster '}must be configured with the{' '}
      <ExternalLink href="https://docs.opensearch.org/docs/latest/security/access-control/users-roles/">
        search role
      </ExternalLink>{' '}
      in order to use the Warm Tier. See the Graylog Documentation on how to{' '}
      <DocumentationLink
        page={DocsHelper.PAGES.DATA_TIERING_WARM_TIER_SETUP}
        text="Prepare Your Environment for a Warm Tier"
      />
      .
    </p>
  );
};

export default WarmTierSnapshotsText;
